import { render, staticRenderFns } from "./OrderBarTotalPart.vue?vue&type=template&id=1691ff31&scoped=true&"
import script from "./OrderBarTotalPart.vue?vue&type=script&lang=ts&"
export * from "./OrderBarTotalPart.vue?vue&type=script&lang=ts&"
import style0 from "./OrderBarTotalPart.vue?vue&type=style&index=0&id=1691ff31&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1691ff31",
  null
  
)

export default component.exports